import moment from 'moment';

export function enumToDropdownOptions(enumObj) {
    return Object.keys(enumObj)
        .filter(key => isNaN(Number(key)))
        .map(key => ({
            label: convertKeyToLabel(key),
            value: enumObj[key]
        }));
}

function convertKeyToLabel(key) {
    if (key === 'White') {
        return "White (Caucasian)";
    } else if (key === 'Latino') {
        return "Latino/Hispanic";
    } else if (key === 'Native') {
        return "Native/Indigenous";
    } else {
        return key;
    }
}

export function formatCurrency(value, locale = 'en-US', currency = 'CAD') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    }).format(value);
}

export function uniqueByProperty(arr, prop) {
    const seen = new Set();
    return arr.filter(item => {
        const val = item[prop];
        if (seen.has(val)) {
            return false;
        } else {
            seen.add(val);
            return true;
        }
    });
}

export function isImageFile(fileName) {
    const imagePattern = /\.(jpg|jpeg|png|gif|bmp|svg|webp|avif)$/i;
    return imagePattern.test(fileName);
}

export function isVideoFile(fileName) {
    const videoPattern = /\.(mp4|avi|mov|mkv|flv|wmv|webm)$/i;
    return videoPattern.test(fileName);
}

export function isNullOrEmpty(obj) {
    if (obj === null || obj === undefined) {
        return true;
    }
    if (typeof obj === 'string' && obj.trim() === '') {
        return true;
    }
    return false;
}

export function isEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function isPhoneNumber(phoneNumber) {
    const phoneRegex = /^(?:\+1\s?)?\(?([2-9][0-8][0-9])\)?[\s.-]?([2-9][0-9]{2})[\s.-]?([0-9]{4})$/;
    return phoneRegex.test(phoneNumber);
}

export function isValidatePassword(password) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>'`-])[A-Za-z\d!@#$%^&*(),.?":{}|<>'`-]{8,}$/;
    return passwordRegex.test(password);
}

export function toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => toCamelCase(item));
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const camelCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
            acc[camelCaseKey] = toCamelCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}


export function toDateFormat(date, format = "YYYY-MM-DD") {
    return moment(date).format(format);
}

export function formatStripePriceToCurrency(priceInCents, currency = 'USD') {
    // Convert the price from cents to the main currency unit
    const priceInDollars = priceInCents / 100;

    // Use Intl.NumberFormat to format the price as currency
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
    }).format(priceInDollars);
}


export function calculateCirclePath(center, radius, points = 32) {
    const path = [];
    const earthRadius = 6371000;
    const lat = center.lat * (Math.PI / 180);
    const lng = center.lng * (Math.PI / 180);

    for (let i = 0; i < points; i++) {
        const angle = (i * 360 / points) * (Math.PI / 180);
        const latOffset = radius / earthRadius * Math.cos(angle);
        const lngOffset = radius / (earthRadius * Math.cos(lat)) * Math.sin(angle);

        const latPoint = lat + latOffset;
        const lngPoint = lng + lngOffset;

        path.push(`${latPoint * (180 / Math.PI)},${lngPoint * (180 / Math.PI)}`);
    }

    return path.join('|');
}

export function isValidUrl(account) {
    try {
        new URL(account);
        return true;
    } catch (_) {
        return false;
    }
}

